import { create } from 'zustand';

const useTimeStore = create(set => ({
  drawerWidth: 100 / 3,
  setDrawerWidth: drawerWidth => set({ drawerWidth }),
  boton1: false,
  setBoton1: boton1 => set({ boton1 }),
  boton2: false,
  setBoton2: boton2 => set({ boton2 }),
  casos: ['Map', 'LayersControl', 'Nada', 'NavBar', 'BotonMenu', 'BotonEditor'],
  setCasos: casos => set({ casos }),
  centerMap: {},
  setCenterMap: centerMap => set({ centerMap }),
  adjustMap: true,
  setAdjustMap: adjustMap => set({ adjustMap }),
  allCoordsAnnotations: {},
  setAllCoordsAnnotations: allCoordsAnnotations => set({ allCoordsAnnotations }),
  checkCenterAnnotation: false,
  setCenterAnnotation: checkCenterAnnotation => set({ checkCenterAnnotation }),
  coordinatesAnnotations: {},
  setCoordinatesAnnotations: coordinatesAnnotations => set({ coordinatesAnnotations }),
  coordsAnnotationTemplate: {},
  setCoordsAnnotationTemplate: coordsAnnotationTemplate => set({ coordsAnnotationTemplate }),
  coordinatesTrackVideo: [],
  setCoordinatesTrackVideo: coordinatesTrackVideo => set({ coordinatesTrackVideo }),
  coordinatesVideoPoint: {},
  setCoordintatesVideoPoint: coordinatesVideoPoint => set({ coordinatesVideoPoint }),
  dataToSend: {},
  setDataToSend: dataToSend => set({ dataToSend }),
  coordOnMap: {},
  setCoordOnMap: coordOnMap => set({ coordOnMap }),
  data: {},
  setData: data => set({ data }),
  edicion: false,
  setEdicion: edicion => set({ edicion }),
  elemento: 0,
  setElemento: elemento => set({ elemento }),
  elementToRender: '',
  setElementToRender: elementToRender => set({ elementToRender }),
  goToCoordinates: [0, 0],
  setGoToCoordinates: goToCoordinates => set({ goToCoordinates }),
  isNotesVideoEditor: '',
  setNotesVideoEditor: isNotesVideoEditor => set({ isNotesVideoEditor }),
  layers: [],
  setLayers: layers => set({ layers }),
  layersTrans: [],
  setLayersTrans: layersTrans => set({ layersTrans }),
  mapTypeView: 'map',
  setMapTypeView: mapTypeView => set({ mapTypeView }),
  geometryConfig: 'none',
  setGeometryConfig: geometryConfig => set({ geometryConfig }),
  proyectedPointTrackVideo: {},
  setProyectedPointTrackVideo: proyectedPointTrackVideo => set({ proyectedPointTrackVideo }),
  save: false,
  setSave: save => set({ save })
}));

export default useTimeStore;
